import { ControlItem } from '../types';
import AddBalanceForm from './Balance/Add';
import MoveBalanceForm from './Balance/Move';
import RemoveBalanceForm from './Balance/Remove';
import CreateBotForm from './Bot/Create';
import EditBotForm from './Bot/Edit';
import RemoveBotForm from './Bot/Remove';
import BotStatesForm from './Bot/States';
import CreateSubscriptionForm from './Subscription/Create';
import EditSubscriptionForm from './Subscription/Edit';
import RemoveSubscriptionForm from './Subscription/Remove';
import SubscriptionStatesForm from './Subscription/States';
import Health from './Health';
import ServicesLogs from './Logs/Services';
import CreateUserForm from './User/Create';
import EditUserForm from './User/Edit';
import PanicSellForm from './User/PanicSell';
import ManagePasswordForm from './User/Password';
import RemoveUserForm from './User/Remove';
import React, { useMemo } from 'react';
import BotLogs from './Logs/Bots';
import ErrorLogs from './Logs/Errors';
import Queues from './Logs/Queues';

interface Props {
  activeItem: ControlItem;
  setActiveItem: React.Dispatch<React.SetStateAction<ControlItem>>;
}
const Content = (props: Props) => {
  const { activeItem, setActiveItem } = props;

  const content = useMemo(() => {
    switch (activeItem) {
      case ControlItem.HealthCheck:
        return <Health setActiveItem={setActiveItem} />;

      case ControlItem.ServiceLogs:
        return <ServicesLogs />;

      case ControlItem.BotLogs:
        return <BotLogs />;

      case ControlItem.ErrorLogs:
        return <ErrorLogs />;

      case ControlItem.Queues:
        return <Queues />;

      case ControlItem.CreateUser:
        return <CreateUserForm />;

      case ControlItem.EditUser:
        return <EditUserForm />;

      case ControlItem.ManagePassword:
        return <ManagePasswordForm />;

      case ControlItem.RemoveUser:
        return <RemoveUserForm />;

      case ControlItem.PanicSell:
        return <PanicSellForm />;

      case ControlItem.CreateBot:
        return <CreateBotForm />;

      case ControlItem.EditBot:
        return <EditBotForm />;

      case ControlItem.RemoveBot:
        return <RemoveBotForm />;

      case ControlItem.BotStates:
        return <BotStatesForm />;

      case ControlItem.AddBalance:
        return <AddBalanceForm />;

      case ControlItem.MoveBalance:
        return <MoveBalanceForm />;

      case ControlItem.RemoveBalance:
        return <RemoveBalanceForm />;

      case ControlItem.CreateSubscription:
        return <CreateSubscriptionForm />;

      case ControlItem.EditSubscription:
        return <EditSubscriptionForm />;

      case ControlItem.RemoveSubscription:
        return <RemoveSubscriptionForm />;

      case ControlItem.SubscriptionStates:
        return <SubscriptionStatesForm />;

      default:
        return null;
    }
  }, [activeItem, setActiveItem]);

  return content;
};

export default React.memo(Content);
